const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDragger(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "dragger",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "art"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_14557",
    "data-name": "Line 14557",
    x1: 1.47,
    y1: 23.57,
    x2: 30.53,
    y2: 23.57,
    style: {
      fill: "none",
      stroke: "#3c4347",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_14558",
    "data-name": "Line 14558",
    x1: 6.31,
    y1: 15.5,
    x2: 25.69,
    y2: 15.5,
    style: {
      fill: "none",
      stroke: "#3c4347",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_14559",
    "data-name": "Line 14559",
    x1: 14.39,
    y1: 7.43,
    x2: 17.61,
    y2: 7.43,
    style: {
      fill: "none",
      stroke: "#3c4347",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "square"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1985",
    "data-name": "Rectangle 1985",
    width: 32,
    height: 32,
    style: {
      fill: "none"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragger);
export default __webpack_public_path__ + "static/media/dragger.a5b437d88f2a91cd388b2b281da5057f.svg";
export { ForwardRef as ReactComponent };